module.exports = __webpack_public_path__ + "static/media/sub-table-type-list.72bfc49e.png";